import React, {Component} from 'react';
import logo from '../../images/pplogo-64.ico';
import './Navbar.css';
import NavbarDrawerButton from '../NavbarDrawer/NavbarDrawerButton';
import NavbarDropdown from './NavbarDropdown.js';
import NavbarNonDropdown from './NavbarNonDropdown.js';
import {company_profile, company_industries, company_team, contact_us} from '../NavbarDrawer/NavbarLinks';


export default class Navbar extends Component {
	constructor(props) {
		super(props);
	}

	render() {
		return (
			<header className="navbar">
				<nav className="navbar_navigation">
					<div className= "navbar_toggle_button">
					<NavbarDrawerButton click={this.props.drawerClickHandler} />
					</div>
					<div className="navbar_logo">
						<a href="/"><img src={logo} /><div>PACIFIC PRINCE</div></a>
					</div>
					<div className="spacer"/>
					<div className="navbar_navigation_items">
						<ul>
							<li><NavbarDropdown headerTitle="ABOUT US" data={company_profile} /></li>
							<li><NavbarDropdown headerTitle="INDUSTRIES" data={company_industries} /></li>
							<li><NavbarDropdown headerTitle="KEY MEMEBERS" data={company_team} /></li>
							<li><NavbarDropdown headerTitle="CONTACT US" data={contact_us} /></li>
						</ul>
					</div>
				</nav>
			</header>
		)
	}
};
